<!--
 * @Author: wbf
 * @LastEditTime: 2023-01-12 11:28:08
 * @Description: 修改别名
-->
<template>
	<div class="box">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<Form @submit="onSubmit" class="vertical_self_form">
			<Field
				v-model="form.alias"
				name="alias"
				:label="$t('webapp.home.bind.alias')"
				:placeholder="$t('webapp.home.bind.alias_placeholder')"
				:show-error-message="false"
				:scroll-to-error="true"
				:rules="[{ required: true, validator: validateAlias }]"
			/>
			<!-- <Field
        v-model="form.username"
        name="username"
        label="昵称"
        placeholder="请输入昵称"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true }]"
      /> -->
			<div style="margin-top: 30px">
				<Button round block type="info" native-type="submit">{{ $t("base.btn.save") }}</Button>
			</div>
		</Form>
	</div>
</template>

<script>
import { Field, Icon, Form, Button, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";
import { mapGetters } from "vuex";

export default {
	name: "ChangeUserName",
	components: { Field, Icon, Form, Button, NavBar },
	data() {
		return {
			form: { alias: "" },
		};
	},
	computed: {
		...mapGetters("auth", ["user"]),
	},
	created() {
		this.getUserInfo();
	},
	methods: {
		// 获取用户信息
		async getUserInfo() {
			const { code, data } = await commonAPI.getAction(`/users/getUserInfo/${this.user.username}`);
			if (code == 0) {
				let obj = data || {};
				this.form = Object.assign(this.form, obj);
			}
		},
		validateAlias(value) {
			if (value != "") {
				let reg = new RegExp(/[^\d|a-z|A-Z|,@.]/);
				if (reg.test(value)) {
					toast(this.$t("webapp.home.bind.alias_error"));
					return false;
				}
				return true;
			}
		},
		async onSubmit(values) {
			console.log("submit", this.user);
			const { code, message } = await commonAPI.postAction(`/users/editUserAlias/${this.user.username}`, { alias: values.alias });
			if (code == 0) {
				toast(message);
				this.$router.push("/mAuthServer");
			} else {
				toast(message);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.box {
	height: 100vh;
	.box-title {
		background: #fff8ee;
		border: 1px solid rgba(255, 152, 0, 0.19);
		color: #ff9800;
		font-size: 14px;
		line-height: 20px;
		text-align: left;
		padding: 5px;
	}
}
</style>
